<template>
  <div
      ref="slidingContainer"
      class="sliding-buttons"
      :style="{ top: position + 'px' }"
  >
    <p class="history" @click.stop="handleToHistory">历史记录</p>
  </div>
</template>

<script>

export default {
  name: "SlidingButtons",
  data() {
    return {
      position: 0, // 初始位置
      startY: 0,
      startTop: 0,
      isDragging: false,
      isDisabled: false, // 防重点击状态
      hasMoved: false, // 是否发生了移动
      dragThreshold: 10, // 拖动阈值，超过这个距离才认为是拖动
      startTarget: null // 记录开始拖动的目标元素
    };
  },
  mounted() {
    // 设置初始位置为屏幕高度的一半
    this.position = window.innerHeight - 90;
    // 限制拖动范围
    this.limitPosition();
    
    // 使用原生事件监听器，绕过 FastClick 和 Vue 事件系统
    this.$nextTick(() => {
      const element = this.$refs.slidingContainer;
      if (element) {
        // 使用原生事件监听器，在捕获阶段处理，优先级更高
        element.addEventListener('touchstart', this.startDrag, { passive: false, capture: true });
        element.addEventListener('mousedown', this.startDrag, { passive: false, capture: true });
      }
    });
  },
  methods: {
    handleToHistory() {
      this.$emit('toHistory');
    },
    startDrag(e) {
      // 阻止默认行为和事件冒泡，防止触发页面滚动和 FastClick 干扰
      e.preventDefault();
      e.stopPropagation();
      
      // 记录开始拖动的目标元素
      this.startTarget = e.target;
      
      // 添加调试日志
      console.log('startDrag triggered', e.type);
      
      this.isDragging = true;
      this.hasMoved = false; // 重置移动标志
      this.startY = e.touches ? e.touches[0].clientY : e.clientY;
      this.startTop = this.position;
      
      // 使用 { passive: false } 允许 preventDefault
      document.addEventListener('touchmove', this.doDrag, { passive: false });
      document.addEventListener('mousemove', this.doDrag, { passive: false });
      document.addEventListener('touchend', this.stopDrag, { passive: false });
      document.addEventListener('touchcancel', this.stopDrag, { passive: false });
      document.addEventListener('mouseup', this.stopDrag);
    },
    doDrag(e) {
      if (!this.isDragging) return;

      e.preventDefault();
      e.stopPropagation();
      
      const y = e.touches ? e.touches[0].clientY : e.clientY;
      const deltaY = y - this.startY;
      
      // 计算移动距离
      const moveDistance = Math.abs(deltaY);
      
      // 如果移动距离超过阈值，标记为已移动
      if (moveDistance > this.dragThreshold) {
        this.hasMoved = true;
      }
      
      // 无论是否超过阈值，都更新位置（这样拖动会更流畅）
      const newPosition = this.startTop + deltaY;
      // 更新位置
      this.position = newPosition;
      // 限制拖动范围
      this.limitPosition();
    },
    stopDrag(e) {
      if (this.isDragging) {
        if (e) {
          // 如果没有发生实际移动，且点击的是 .history 元素，则触发点击事件
          if (!this.hasMoved && this.startTarget) {
            const historyElement = this.startTarget.closest('.history');
            if (historyElement) {
              // 延迟触发点击事件，确保拖动事件已处理完毕
              this.$nextTick(() => {
                this.handleToHistory();
              });
            }
          }
          // 如果发生了实际移动，阻止默认行为
          if (this.hasMoved) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
        this.isDragging = false;
        this.hasMoved = false;
        this.startTarget = null;
        // removeEventListener 不需要传递选项对象，只需要函数引用
        document.removeEventListener('touchmove', this.doDrag);
        document.removeEventListener('mousemove', this.doDrag);
        document.removeEventListener('touchend', this.stopDrag);
        document.removeEventListener('touchcancel', this.stopDrag);
        document.removeEventListener('mouseup', this.stopDrag);
      }
    },
    limitPosition() {
      // 获取按钮高度
      const buttonHeight = 160;
      const maxTop = window.innerHeight - buttonHeight;
      // 限制在屏幕范围内
      this.position = Math.max(0, Math.min(this.position, maxTop));
    }
  },
  beforeDestroy() {
    // 清理事件监听器
    const element = this.$refs.slidingContainer;
    if (element) {
      element.removeEventListener('touchstart', this.startDrag, { capture: true });
      element.removeEventListener('mousedown', this.startDrag, { capture: true });
    }
    document.removeEventListener('touchmove', this.doDrag);
    document.removeEventListener('mousemove', this.doDrag);
    document.removeEventListener('touchend', this.stopDrag);
    document.removeEventListener('touchcancel', this.stopDrag);
    document.removeEventListener('mouseup', this.stopDrag);
  }
};
</script>

<style scoped lang="scss">
@import "../../common/scss/rem";
.sliding-buttons {
  position: fixed;
  right: pr(0);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: grab;
  touch-action: none !important; /* 禁用浏览器默认的触摸行为，允许自定义拖动 */
  -webkit-touch-callout: none; /* 禁用长按菜单 */
  -webkit-user-select: none; /* 禁用文本选择 */
  user-select: none;
  pointer-events: auto; /* 确保可以接收触摸事件 */
}
.history{
  position: relative; /* 改为 relative，让它跟随父元素 */
  font-size: pr(15);
  color: #0093FF;
  padding: pr(6) pr(8) pr(6) pr(12);
  background: #FFFFFF;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  box-shadow: pr(0) pr(2) pr(5) rgba(0, 0, 0, 0.059741);
  border-radius: pr(40) 0 0 pr(40);
  touch-action: none; /* 也禁用子元素的触摸行为 */
  pointer-events: auto; /* 确保可以接收点击事件 */
}
</style>
